import type {
	MessagePreviewPart,
	MessageVariableKind,
	MessageVariableOption,
} from "@/shared/api/generated/types/marketing"

export const MESSAGE_VARIABLES_FIXTURE: MessageVariableOption[] = [
	{ key: "name", token: "{имя}", label: "имя", kind: "text", insertable: true },
	{
		key: "branch",
		token: "{филиал}",
		label: "филиал",
		kind: "text",
		insertable: true,
	},
	{
		key: "doctor",
		token: "{врач}",
		label: "врач",
		kind: "text",
		insertable: true,
	},
	{
		key: "image",
		token: "{картинка}",
		label: "картинка",
		kind: "image",
		insertable: false,
	},
]

const defaultPreviewSamples: Record<string, string> = {
	"{имя}": "Анна",
	"{филиал}": "Главный филиал",
	"{врач}": "Иванов И.И.",
}

function escapeRegExp(value: string) {
	return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
}

export function getMessageVariablesFixture() {
	return { variables: MESSAGE_VARIABLES_FIXTURE }
}

export function findImageMessageVariable(
	variables: MessageVariableOption[] = MESSAGE_VARIABLES_FIXTURE,
) {
	return variables.find((variable) => variable.kind === "image") ?? null
}

export function buildMessagePreviewParts({
	text,
	previewMediaUrl,
	variables = MESSAGE_VARIABLES_FIXTURE,
}: {
	text: string
	previewMediaUrl?: string | null
	variables?: MessageVariableOption[]
}): MessagePreviewPart[] {
	const samples = defaultPreviewSamples
	const tokenPattern = variables
		.map((variable) => escapeRegExp(variable.token))
		.join("|")
	const splitPattern = new RegExp(`(${tokenPattern}|https?:\\/\\/[^\\s]+)`, "g")
	const segments = text
		.split(splitPattern)
		.filter((segment) => segment.length > 0)
	const parts: MessagePreviewPart[] = []

	for (const segment of segments) {
		const variable = variables.find((item) => item.token === segment)
		if (variable) {
			if (variable.kind === "image") {
				if (previewMediaUrl) {
					parts.push({ type: "image", url: previewMediaUrl })
				} else {
					parts.push({
						type: "placeholder",
						token: variable.token,
						label: variable.label,
						kind: variable.kind as MessageVariableKind,
					})
				}
				continue
			}

			parts.push({
				type: "text",
				content: samples[variable.token] ?? variable.label,
			})
			continue
		}

		if (/^https?:\/\//.test(segment)) {
			parts.push({ type: "link", url: segment })
			continue
		}

		parts.push({ type: "text", content: segment })
	}

	return parts
}

export function buildPreviewText({
	text,
	variables = MESSAGE_VARIABLES_FIXTURE,
}: {
	text: string
	variables?: MessageVariableOption[]
}) {
	const samples = defaultPreviewSamples

	return variables.reduce((result, variable) => {
		if (variable.kind !== "text") {
			return result
		}

		const sample = samples[variable.token]
		if (!sample) {
			return result
		}

		return result.replaceAll(variable.token, sample)
	}, text)
}
